import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import { toast } from "react-toastify";
import { Modal as AntModal } from "antd";
import PDFview from "../../../components/PdfView";
import Modal from "react-modal";

const PackingListView = (props) => {
  const { addForm, update } = props;
  const [data, setData] = useState([]);

  const [docurl, setDocUrl] = useState(false);
  const [customsPackingListId, setCustomsPackingListId] = useState("");

  const { sendRequest: getPackingList } = useHttp();

  useEffect(() => {
    getPackingList(
      {
        url: "/api/packingList/",
      },
      (res) => {
        if (res) {
          setData(res);
          //console.log(res);
        }
      }
    );
  }, [getPackingList]);

  const viewPdf = (itemId) => {
    setDocUrl("https://www.orimi.com/pdf-test.pdf");
    setCustomsPackingListId(itemId);
  };

  const { sendRequest: formDataDelete } = useHttp();

  const deleteHandler = (e, customsPackingListId) => {
    e.preventDefault();
    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this Customs Packing List detail?",
      onOk() {
        const data = {
          customsPackingListId: customsPackingListId,
        };
        //console.log(data);

        formDataDelete(
          {
            url: "/api/profarmaInvoice/",
            method: "DELETE",
            body: data,
          },
          (data) => {
            toast.success(data);
          }
        );
      },
      onCancel() {},
    });
  };
  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      zIndex: 1000,
    },
    content: {
      top: "55%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "800px", // Adjust the width as needed
      height: "80%",
      minHeight: "400px",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (data) => {
    setSelectedData(data);
    //console.log(data);

    setIsModalOpen(true);
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-3 my-3">Customs Packing List</label>
          </div>

          <div className="col-6 text-right">
            <button
              type="button"
              className="btn  btn-primary mx-3 my-3"
              onClick={() => {
                addForm(true);
                props.update(false);
              }}
            >
              Add Packing List
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-responsive text-center">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Packing List id </th>
                          <th>Commercial Invoice Id</th>
                          <th>Proforma Invoice id</th>
                          <th>Method of Dispatch</th>
                          <th>Customer Name</th>
                          <th>currency Code</th>
                          <th>Type of Shipment</th>

                          {/* <th>Edit</th> */}
                          <th>Delete</th>
                          <th>Pdf</th>
                          <th>View</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i}>
                                <td>{itm.customsPackingDate}</td>
                                <td>{itm.customsPackingNo}</td>
                                <td>{itm.commercialInvoiceNo}</td>
                                <td>{itm.profarmaInvoiceNo}</td>
                                <td>{itm.methodOfDispatch}</td>
                                <td>{itm.customerName}</td>
                                <td>{itm.currencyCode}</td>
                                <td>{itm.typeOfShipment}</td>

                                {/* <td>
                                  {itm.isGoodReciept === "Yes" ? (
                                    <button className="btn" disabled>
                                      <i className="fas fa-edit"></i>
                                    </button>
                                  ) : (
                                    <button
                                      onClick={() => {
                                        props.update(itm);
                                        props.addForm(true);
                                      }}
                                      className="btn"
                                    >
                                      <i className="fas fa-edit"></i>
                                    </button>
                                  )}
                                </td> */}
                                <td>
                                  {itm.isGoodReciept === "Yes" ? (
                                    <button className="btn" disabled>
                                      <i className="fas fa-trash"></i>
                                    </button>
                                  ) : (
                                    <button
                                      className="btn"
                                      onClick={(e) =>
                                        deleteHandler(
                                          e,
                                          itm.customsPackingListId
                                        )
                                      }
                                    >
                                      <i className="fas fa-trash"></i>
                                    </button>
                                  )}
                                </td>
                                <td>
                                  <button
                                    className="btn"
                                    onClick={() =>
                                      viewPdf(itm.customsPackingListId)
                                    }
                                  >
                                    <i className="fas fa-solid fa-file"></i>
                                  </button>
                                </td>

                                <td>
                                  <button
                                    className="btn"
                                    onClick={() => openModal(itm)}
                                  >
                                    <i className="fas fa-eye"></i>
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      {docurl && (
        <Modal isOpen={true} style={customModalStyles}>
          {customsPackingListId && (
            <div className="row">
              <div className="col-md-11">
                <button
                  className="btn btn-sm btn-success"
                  onClick={() =>
                    window.open(
                      `${process.env.REACT_APP_BASE_URL}/api/customsPackingList_pdf/?customsPackingListId=${customsPackingListId}`,
                      "_blank"
                    )
                  }
                >
                  Download
                </button>
              </div>
              <div className="col-md-1">
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="remove"
                    onClick={() => setDocUrl(false)}
                  >
                    <i className="fas fa-times" />
                  </button>
                </div>
              </div>
            </div>
          )}
          <PDFview
            docurl={`${process.env.REACT_APP_BASE_URL}/api/customsPackingList_pdf/?customsPackingListId=${customsPackingListId}`}
          />
        </Modal>
      )}

      {/* view modal */}
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        {selectedData && (
          <div className="mx-3">
            <h4 className="card-title">Customs Packing List Details</h4>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setIsModalOpen(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
            <div className="row">
              <p className="col-md-6">
                Customs Packing List No: {selectedData.customsPackingNo}
              </p>
              <p className="col-md-6">
                Commercial Invoice No: {selectedData.commercialInvoiceNo}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Customs Packing List Date: {selectedData.customsPackingDate}
              </p>
              <p className="col-md-6">
                Date of Departure : {selectedData.dateOfDeparture}
              </p>
            </div>

            <div className="row">
              <p className="col-md-6">
                Customer Name: {selectedData.customerName}
              </p>

              <p className="col-md-6">
                Method of Dispatch: {selectedData.methodOfDispatch}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Type of Shipment: {selectedData.typeOfShipment}
              </p>
              <p className="col-md-6">
                Country of Origin of Goods:{" "}
                {selectedData.countryOfOriginofGoods}
              </p>
            </div>

            <div className="row">
              <p className="col-md-6">
                Final Destination: {selectedData.finalDestination}
              </p>
              <p className="col-md-6">
                Vessel/Aircraft Name : {selectedData.vesselAircreftName}
              </p>
            </div>

            <div className="row">
              <p className="col-md-6">Voyage Number: {selectedData.voyageNo}</p>
              <p className="col-md-6">
                Port of Loading: {selectedData.portOfLoading}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Port Of Discharge: {selectedData.portOfDischarge}
              </p>

              <p className="col-md-6">
                Packing Information : {selectedData.PackingInformation}
              </p>
            </div>

            <div className="row">
              <p className="col-md-6">
                Country of Final Destination:{" "}
                {selectedData.countryofFinalDestination}
              </p>
              <p className="col-md-6">
                Bill of Lading/Airway Bill Numbe: {selectedData.billOfLoading}
              </p>
            </div>

            <div className="row">
              <p className="col-md-6">
                Name of Authorized Signatory:{" "}
                {selectedData.nameOfAuthorizedSignatory}
              </p>
              <p className="col-md-6">
                Place of Issue: {selectedData.placeOfIssue}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">Remark/Note: {selectedData.remark}</p>
              <p className="col-md-6">Currency: {selectedData.currencyName}</p>
            </div>
            <h5>Reference Numbers Details</h5>
            <table className="table table-bordered table-sm text-center w-50">
              <thead>
                <tr>
                  <th>Shipper Reference No</th>
                  <th>Buyer Reference No</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {selectedData.referenceNo[0] &&
                      selectedData.referenceNo[0].shipperReferenceNumber}
                  </td>
                  <td>
                    {selectedData.referenceNo[0] &&
                      selectedData.referenceNo[0].buyerReferenceNumber}
                  </td>
                </tr>
              </tbody>
            </table>

            <h5>Product Details</h5>
            <table className="table table-bordered table-responsive table-sm text-center">
              <thead>
                <tr>
                <th>Sr. No</th>
                <th>Item Id</th>
                <th>Product Name</th>
                <th>Unit Quantity</th>
                <th>Unit</th>
                <th>Kind & No. of Packages</th>

                <th>Net Weight(kg)</th>

                <th>Gross Weight(kg)</th>
                <th>Measurements(m³)</th>
                </tr>
              </thead>
              <tbody>
                {selectedData.productDetails &&
                  selectedData.productDetails.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{itm.productName}</td>

                        <td>{itm.itemId}</td>
                        <td>{itm.productName}</td>
                        <td>{itm.deliveryDispatchQuantity}</td>
                        <td>{itm.unitAbbreviation}</td>
                        <td>{itm.MarksNumber}</td>
                        <td>{itm.KindNoOfPackages}</td>
                        <td>{itm.totalGrossWeight}</td>
                        <td>{itm.measurements}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>

            <h5>Notify Party Details</h5>
            <table className="table table-bordered table-responsive table-sm text-center">
              <thead>
                <tr>
                  <th>Sr. No</th>

                  <th>Party Type</th>
                  <th>Name</th>
                  <th>Email Id</th>
                  <th>Contact Person Name</th>
                  <th>Contact Number</th>
                  <th>Address(landmark)</th>
                  <th>City</th>
                  <th>State</th>
                  <th>Zip Code</th>
                  <th>Country</th>
                </tr>
              </thead>
              <tbody>
                {selectedData.buyerDetails &&
                  selectedData.buyerDetails.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{itm.partyType}</td>

                        <td>{itm.name}</td>
                        <td>{itm.email}</td>
                        <td>{itm.contactPersonName}</td>
                        <td>{itm.contactNumber}</td>
                        <td>{itm.landmark}</td>
                        <td>{itm.city}</td>
                        <td>{itm.state}</td>
                        <td>{itm.zipcode}</td>
                        <td>{itm.country}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        )}
      </Modal>
    </>
  );
};

export default PackingListView;
